var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper",class:{ color: _vm.color },style:(_vm.style)},[_c('app-nav',{staticClass:"app-nav"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }